// extracted by mini-css-extract-plugin
export default {"wrapper":"-n-Gj","container":"_8J54z","title":"kjMDI","createProjectButtonWrapper":"sDLKe","orgTitle":"_50HAR","chosenOrganization":"rmCLs"};